"use client";

import { c as _c } from "react/compiler-runtime";
import { TextLeftLayout } from "@/components/text-left/text-left-layout";
import { RichTextAccordion } from "@/components/common/rich-text/rich-text-accordion.component";
import type { TextLeftAccordionProps } from "./text-left-accordion.types";
export function TextLeftAccordion(t0) {
  const $ = _c(18);
  const {
    overline,
    headline,
    body,
    actions,
    isTabbedDisplay,
    content,
    tabs,
    className
  } = t0;
  if (isTabbedDisplay && tabs && tabs.length > 0) {
    let t1;
    if ($[0] !== tabs) {
      t1 = tabs.map(_temp);
      $[0] = tabs;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== actions || $[3] !== body || $[4] !== className || $[5] !== headline || $[6] !== overline || $[7] !== t1) {
      t2 = <TextLeftLayout overline={overline} headline={headline} body={body} actions={actions} className={className} tabs={t1} />;
      $[2] = actions;
      $[3] = body;
      $[4] = className;
      $[5] = headline;
      $[6] = overline;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  let t1;
  if ($[9] !== content) {
    t1 = content ? <RichTextAccordion richText={content} /> : null;
    $[9] = content;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== actions || $[12] !== body || $[13] !== className || $[14] !== headline || $[15] !== overline || $[16] !== t1) {
    t2 = <TextLeftLayout overline={overline} headline={headline} body={body} actions={actions} className={className}>{t1}</TextLeftLayout>;
    $[11] = actions;
    $[12] = body;
    $[13] = className;
    $[14] = headline;
    $[15] = overline;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}
function _temp(tab) {
  return {
    key: tab.key,
    label: tab.label,
    content: tab.content ? <RichTextAccordion richText={tab.content} /> : null
  };
}